import { render } from "./ViewCollectorCharges.vue?vue&type=template&id=1cfaa6da&scoped=true"
import script from "./ViewCollectorCharges.vue?vue&type=script&lang=js"
export * from "./ViewCollectorCharges.vue?vue&type=script&lang=js"

import "./ViewCollectorCharges.vue?vue&type=style&index=0&id=1cfaa6da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfaa6da"]])

export default __exports__